<template>
  <el-dialog
      :modal="false"
      :visible.sync="publishModal"
      class="pbr-add-project"
      :title="title"
      top="20px"
      width="1000px"
  >
    <div v-if="!readonly" slot="footer" style="text-align: center;">
      <Button :loading="publishModalLoading" type="primary" @click="submitForm"
      >{{ $t('buttons.submit') }}
      </Button
      >
      <Button @click="test">{{ $t('buttons.cancelButton') }}</Button>
    </div>
    <template #title>
      <div>
        <div class="pbr-title">{{ modalTitle }}</div>
      </div>
    </template>
    <el-form
        ref="publishForm"
        :disabled='readonly'
        :model="publishForm"
        :rules="formRules"
        :label-width="labelWidth"
    >
      <el-collapse v-model="activeNames">
        <el-collapse-item name="baseInfo" :title="$t('label.project.publish.base.title')">
          <template slot="title">
            <strong>
              <i class="el-icon-document pbr-add-project-icon"></i>{{$t('label.project.publish.base.title')}}
            </strong>
          </template>
          <div class="pbr-add-project-form-item-container">
            <el-form-item :label="$t('label.project.publish.base.projectName')" prop="title">
              <el-input
                  v-model="publishForm.title"
                  :placeholder="$t('placeholders.project.publish.base.projectName')"
                  size="small"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('label.project.publish.base.investmentAmount')" prop="planInvest">
              <el-input
                  v-model="publishForm.planInvest"
                   :placeholder="$t('placeholders.project.publish.base.investmentAmount')"
                  size="small"
              ></el-input>
            </el-form-item>
          </div>
          <div class="pbr-add-project-form-item-container">
            <el-form-item :label="$t('label.project.publish.base.projectCountry')" prop="countryId">
              <el-cascader
                  v-model="publishForm.countryId"
                  :options="countryModels"
                  :props="cprops"
                  clearable
                  filterable
                   :placeholder="$t('placeholders.project.publish.base.projectCountry')"
                  size="small"
                  @change="selectCountryChanged"
              ></el-cascader>
            </el-form-item>
            <el-form-item :label="$t('label.project.publish.base.detailedAddress')" prop="address">
              <el-input
                  v-model="publishForm.address"
                   :placeholder="$t('placeholders.project.publish.base.detailedAddress')"
                  size="small"
              ></el-input>
            </el-form-item>
          </div>
          <div class="pbr-add-project-form-item-container">
            <el-form-item :label="$t('label.project.publish.base.projectIndustry')" prop="industryId">
              <el-select
                  v-model="publishForm.industryId"
                   :placeholder="$t('placeholders.project.publish.base.projectIndustry')"
                  size="small"
                  @change="selectIndustryChanged"
              >
                <template v-for="item in industryModels">
                  <el-option
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('label.project.publish.base.projectType')" prop="typeId">
              <el-select
                  v-model="publishForm.typeId"
                   :placeholder="$t('placeholders.project.publish.base.projectType')"
                  size="small"
                  @change="selectTypeChanged"
              >
                <template v-for="item in typeModels">
                  <el-option
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
          <div class="pbr-add-project-form-item-container">
            <el-form-item :label="$t('label.project.publish.base.participationMode')" prop="executeId">
              <el-select
                  v-model="publishForm.executeId"
                   :placeholder="$t('placeholders.project.publish.base.participationMode')"
                  size="small"
                  @change="selectExecuteChanged"
              >
                <template v-for="item in executeModels">
                  <el-option
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('label.project.publish.base.projectStatus')" prop="stageId">
              <el-select
                  v-model="publishForm.stageId"
                   :placeholder="$t('placeholders.project.publish.base.projectStatus')"
                  size="small"
                  @change="selectStageChanged"
              >
                <template v-for="stageobj in stageModels">
                  <el-option
                      :key="stageobj.id"
                      :label="stageobj.name"
                      :value="stageobj.id"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
          <div class="pbr-add-project-form-item-container">
            <el-form-item :label="$t('label.project.publish.base.unitName')" prop="buildUnit">
              <el-input
                  v-model="publishForm.buildUnit"
                   :placeholder="$t('placeholders.project.publish.base.unitName')"
                  size="small"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('label.project.publish.base.financingSituation')" prop="financingInfo">
              <el-input
                  v-model="publishForm.financingInfo"
                   :placeholder="$t('placeholders.project.publish.base.financingSituation')"
                  size="small"
              ></el-input>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div
                v-if="showContract"
                class="pbr-add-project-form-item-container"
            >
              <el-form-item :label="$t('label.project.publish.base.signDate')" >
                <el-date-picker
                    v-model="publishForm.signDate"
                     :placeholder="$t('placeholders.project.publish.base.signDate')"
                    size="small"
                    style="width:100%;"
                    type="date"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('label.project.publish.base.signAmount')" prop="signAmount">
                <el-input
                    v-model="publishForm.signAmount"
                     :placeholder="$t('placeholders.project.publish.base.signAmount')"
                    size="small"
                ></el-input>
              </el-form-item>
            </div>
          </el-collapse-transition>
          <el-collapse-transition>
            <div v-if="showTime" class="pbr-add-project-form-item-container">
              <el-form-item :label="$t('label.project.publish.base.planStartDate')" >
                <el-date-picker
                    v-model="publishForm.planStartDate"
                     :placeholder="$t('placeholders.project.publish.base.planStartDate')"
                    size="small"
                    style="width:100%;"
                    type="date"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('label.project.publish.base.planEndDate')" >
                <el-date-picker
                    v-model="publishForm.planEndDate"
                     :placeholder="$t('placeholders.project.publish.base.planEndDate')"
                    size="small"
                    style="width:100%;"
                    type="date"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('label.project.publish.base.realityStartDate')" >
                <el-date-picker
                    v-model="publishForm.realityStartDate"
                     :placeholder="$t('placeholders.project.publish.base.realityStartDate')"
                    size="small"
                    style="width:100%;"
                    type="date"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('label.project.publish.base.realityEndDate')" >
                <el-date-picker
                    v-model="publishForm.realityEndDate"
                     :placeholder="$t('placeholders.project.publish.base.realityEndDate')"
                    size="small"
                    style="width:100%;"
                    type="date"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('label.project.publish.base.planBuildCycle')">
                <el-input
                    v-model="publishForm.planBuildCycle"
                     :placeholder="$t('placeholders.project.publish.base.planBuildCycle')"
                    size="small"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('label.project.publish.base.realityBuildCycle')">
                <el-input
                    v-model="publishForm.realityBuildCycle"
                     :placeholder="$t('placeholders.project.publish.base.realityBuildCycle')"
                    size="small"
                ></el-input>
              </el-form-item>
            </div>
          </el-collapse-transition>
          <div class="pbr-add-project-form-item-container">
            <el-form-item :label="$t('label.project.publish.base.lang')" prop="language">
              <el-select
                v-model="publishForm.language"
                :placeholder="$t('placeholders.project.publish.base.lang')"
                size="small"
              >
                <el-option
                  v-for="item in $t('langList')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pbr-add-project-form-item-container flex-fill">
            <el-form-item :label="$t('label.project.publish.base.overview')" prop="summarize">
              <el-input
                  v-model="publishForm.summarize"
                  clearable
                  maxlength="500"
                   :placeholder="$t('placeholders.project.publish.base.overview')"
                  show-word-limit
                  type="textarea"
              ></el-input>
            </el-form-item>
          </div>
        </el-collapse-item>
<!--        <el-collapse-item name="contact" :title="$t('label.project.publish.contact.title')">-->
<!--          <template slot="title">-->
<!--            <strong>-->
<!--              <i class="el-icon-user-solid pbr-add-project-icon"></i>{{ $t('label.project.publish.contact.title') }}-->
<!--            </strong>-->
<!--          </template>-->
<!--          <div class="pbr-add-project-form-item-container">-->
<!--            <el-form-item :label="$t('label.project.publish.contact.contact1')" prop="contactName">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactName"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.contact1')"-->
<!--                  size="small"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('label.project.publish.contact.mobile1')" prop="contactMobile">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactMobile"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.mobile1')"-->
<!--                  size="small"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--          </div>-->
<!--          <div class="pbr-add-project-form-item-container">-->
<!--            <el-form-item :label="$t('label.project.publish.contact.email1')" prop="contactMailBox">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactMailBox"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.email1')"-->
<!--                  size="small"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('label.project.publish.contact.telephone1')" prop="contactPhone">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactPhone"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.telephone1')"-->
<!--                  size="small"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--          </div>-->
<!--          <div class="pbr-add-project-form-item-container">-->
<!--            <el-form-item :label="$t('label.project.publish.contact.contact2')" prop="contactName2">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactName2"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.contact2')"-->
<!--                  size="small"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('label.project.publish.contact.mobile2')" prop="contactMobile2">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactMobile2"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.mobile2')"-->
<!--                  size="small"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--          </div>-->
<!--          <div class="pbr-add-project-form-item-container">-->
<!--            <el-form-item :label="$t('label.project.publish.contact.email2')" prop="contactMailBox2">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactMailBox2"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.email2')"-->
<!--                  size="small"-->
<!--                  type="email"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('label.project.publish.contact.telephone2')" prop="contactPhone2">-->
<!--              <el-input-->
<!--                  v-model="publishForm.contactPhone2"-->
<!--                   :placeholder="$t('placeholders.project.publish.contact.telephone2')"-->
<!--                  size="small"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="pbr-add-project-form-item-container">&ndash;&gt;-->
<!--&lt;!&ndash;            <el-form-item :label="$t('label.project.publish.base.projectName')"附件材料">&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;              <el-upload&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                  action="http://124.71.59.22:7999/front/myproject/attachment"&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                  class="upload-demo"&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                  drag&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                  multiple&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                  :on-success="loadSucceed"&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;              >&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                <i class="el-icon-upload"></i>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                <div class="el-upload__text">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                  将文件拖到此处，或<em>点击上传</em>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;                </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              &lt;!&ndash;              </el-upload>&ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;              <el-upload&ndash;&gt;-->
<!--&lt;!&ndash;                  :limit="3"&ndash;&gt;-->
<!--&lt;!&ndash;                  :on-remove="handleRemove"&ndash;&gt;-->
<!--&lt;!&ndash;                  :on-success="loadSucceed"&ndash;&gt;-->
<!--&lt;!&ndash;                  action="http://124.71.59.22:7999/front/myproject/attachment"&ndash;&gt;-->
<!--&lt;!&ndash;                  class="upload-demo"&ndash;&gt;-->
<!--&lt;!&ndash;                  multiple&ndash;&gt;-->
<!--&lt;!&ndash;              >&ndash;&gt;-->
<!--&lt;!&ndash;                <el-link type="primary" :underline="false">点击上传</el-link>&ndash;&gt;-->
<!--&lt;!&ndash;              </el-upload>&ndash;&gt;-->

<!--&lt;!&ndash;            </el-form-item>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </el-collapse-item>-->
      </el-collapse>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'pbrPublishProject',
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default(){
        return this.$t('label.project.publish.title')
      }
    },
    succeed: {
      type: Function
    }
  },
  data () {
    return {
      modalTitle: this.title,
      activeNames: ['baseInfo', 'contact'],
      publishModal: false,
      publishModalLoading: false,
      showTime: false,
      showContract: false,
      formRules: {
        title: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.projectName')
          },
          {max: 100, message: this.$t('rules.publishProject.maximum100') , trigger: 'blur'}
        ],
        planInvest: [
          {
            required: true,
            message:  this.$t('placeholders.project.publish.base.investmentAmount')
          },
          {
            validator: this.amountValidator,
            trigger: 'blur',
            message: this.$t('rules.publishProject.number')
          },
          {max: 20, message: this.$t('rules.maximum',{num: 50}) , trigger: 'blur'}
        ],
        countryId: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.projectCountry')
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.detailedAddress')
          },
          {max: 100, message: this.$t('rules.publishProject.maximum100'), trigger: 'blur'}
        ],
        industryId: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.projectIndustry')
          }
        ],
        typeId: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.projectType')
          }
        ],
        executeId: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.participationMode')
          }
        ],
        stageId: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.projectStatus')
          }
        ],
        signAmount: [
          {
            validator: this.amountValidator,
            trigger: 'blur',
            message: this.$t('rules.publishProject.number')
          },
          {max: 20, message: this.$t('rules.maximum',{num: 20}) , trigger: 'blur'}
        ],
        buildUnit: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.unitName')
          },
          {max: 100, message: this.$t('rules.publishProject.maximum100'), trigger: 'blur'}
        ],
        financingInfo: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.financingSituation')
          },
          {max: 100, message: this.$t('rules.publishProject.maximum100'), trigger: 'blur'}
        ],
        summarize: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.overview')
          }
        ],
        contactName: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.contact1')
          },
          {max: 50, message: this.$t('rules.publishProject.maximum50'), trigger: 'blur'}
        ],
        contactMobile: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.mobile1')
          },
          {
            validator: this.tel_validator,
            trigger: 'blur',
            message: this.$t('rules.publishProject.contact.mobile1')
          },
        ],
        contactPhone: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.telephone1')
          },
          {max: 50, message: this.$t('rules.publishProject.maximum50'), trigger: 'blur'}
        ],
        contactMailBox: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.email1')
          },
          {
            validator: this.mail_validator,
            trigger: 'blur',
            message: this.$t('rules.publishProject.contact.email1')
          },
          {max: 50, message: this.$t('rules.publishProject.maximum50'), trigger: 'blur'}
        ],
        contactName2: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.contact2')
          },
          {max: 50, message: this.$t('rules.publishProject.maximum50'), trigger: 'blur'}
        ],
        contactMobile2: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.mobile2')
          },
          {
            validator: this.tel_validator,
            trigger: 'blur',
            message: this.$t('rules.publishProject.contact.mobile2')
          }
        ],
        contactPhone2: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.telephone2')
          },
          {max: 50, message: this.$t('rules.publishProject.maximum50'), trigger: 'blur'}
        ],
        contactMailBox2: [
          {
            required: true,
            message: this.$t('placeholders.project.publish.contact.email2')
          },
          {
            validator: this.mail_validator,
            trigger: 'blur',
            message: this.$t('rules.publishProject.contact.email2')
          },
          {max: 50, message: this.$t('rules.publishProject.maximum50'), trigger: 'blur'}
        ],
        language:[
          {
            required: true,
            message: this.$t('placeholders.project.publish.base.lang')
          },
        ]
      },
      publishForm: {
        title: '',
        summarize: '',
        countryId: '',
        countryName: '',
        address: '',
        industryId: '',
        industryName: '',
        typeId: '',
        typeName: '',
        stageId: '',
        stageName: '',
        planInvest: '',
        signAmount: '',
        buildUnit: '',
        signDate: '',
        planStartDate: '',
        planEndDate: '',
        realityStartDate: '',
        realityEndDate: '',
        planBuildCycle: '',
        realityBuildCycle: '',
        executeId: '',
        executeName: '',
        financingInfo: '',
        contactName: '',
        contactMobile: '',
        contactPhone: '',
        contactMailBox: '',
        contactName2: '',
        contactMobile2: '',
        contactPhone2: '',
        contactMailBox2: '',
        accessoryPath: '',
        language:''
      },

      countryModels: [],
      companyModels: [],
      industryModels: [],
      typeModels: [],
      parkModels: [],
      stageModels: [],
      executeModels: [],
      financingModels: [],
      cprops: {
        value: 'id',
        label: 'name',
        emitPath: false // 只返回当前选中的国家结点
      },
      locale: localStorage.getItem('locale')
    }
  },
  computed:{
    labelWidth(){
      return this.locale === 'en' ? '155px' : '107px'
    }
  },
  methods: {
    open (form) {
      this.fetchRegionList()
      this.fetchGConditions()
      this.publishModal = true
      this.$nextTick(n => {
        this.$refs.publishForm.resetFields()
        if (form) {
          this.modalTitle = form.title
          this.publishForm = {...this.publishForm, ...form}
        }
      })

    },
    close () {
      this.publishModal = false
    },
    test () {
      this.close()
      // this.$iMessage.success({
      //   content: '发布成功',
      //   duration: 100000,
      //   top: 10,
      //   closable: true,
      //   onClose: () => {
      //     this.close()
      //   }
      // })
    },
    selectCountryChanged (countryId) {
      let filterCountry = this.countryModels.find(
        country => country.id === countryId
      )
      this.publishForm.countryName = filterCountry.name
    },
    selectIndustryChanged (industryId) {
      let filterIndustry = this.industryModels.find(
        industry => industry.id === industryId
      )
      this.publishForm.industryName = filterIndustry.name
    },
    selectExecuteChanged (executeId) {
      let filterExecute = this.executeModels.find(
        execute => execute.id === executeId
      )
      this.publishForm.executeName = filterExecute.name
    },
    selectStageChanged (selectedValue) {
      let filterStage = this.stageModels.find(
        stg => stg.id === selectedValue
      )
      this.publishForm.stageName = filterStage.name
      if (filterStage.name === this.$t('label.signAContract') || filterStage.name === this.$t('label.implement')) {
        this.showContract = true
        if (this.publishForm.typeName === this.$t('label.capitalConstruction')) {
          this.showTime = true
        }
      } else {
        this.showTime = false
        this.showContract = false
      }
    },
    selectTypeChanged (selectedValue) {
      let filterType = this.typeModels.find(type => type.id === selectedValue)
      this.publishForm.typeName = filterType.name
      if (filterType.name === this.$t('label.capitalConstruction')) {
        if (
          this.publishForm.stageName === this.$t('label.signAContract') ||
            this.publishForm.stageName === this.$t('label.implement')
        ) {
          this.showTime = true
        } else {
          this.showTime = false
        }
      } else {
        this.showTime = false
      }
    },
    addAttachment () {
      this.$pbrApis.addMyprojectGAttachment({from: this.locale}).then(res => {
        console.log(res)

        if (!res) {
          this.$message.error({content: '上传附件失败', duration: 5})
        } else if (res.success) {
        }
      })
    },
    fetchRegionList () {
      this.$pbrApis
        .fetchRegionList({pid: 0, level: 1, type: 'a', from: this.locale})
        .then(res => {
          if (res){
            console.log('发布项目获取国家列表接口', res)
            this.countryModels = res.result
          }

        })
    },
    fetchGConditions () {
      this.$pbrApis.fetchMyprojectGConditions({from: this.locale}).then(res => {
        console.log('发布项目下拉条件', res)

        if (!res) {
          this.$message.error({
            content: '获取发布项目部分条件信息失败',
            duration: 5
          })
        } else if (res.success) {
          this.companyModels = res.result.companyModels
          this.industryModels = res.result.industryModels
          this.typeModels = res.result.typeModels
          this.parkModels = res.result.parkModels
          this.stageModels = res.result.stageModels
          this.executeModels = res.result.executeModels
          this.financingModels = res.result.financingModels
        }
      })
    },
    publish () {
      this.$pbrApis.publishMyproject(this.publishForm).then(res => {
        this.publishModalLoading = false;
        if (!res) {
          this.$message.error({content: this.$t('label.project.publish.submitFailure'), duration: 5})
        } else if (res.success) {
          this.$message.success({
            content: this.$t('label.project.publish.submitSuccess'),
            duration: 100000,
            top: 10,
          })
          this.close()
          this.succeed && this.succeed()
        } else {
          this.$message.error({content: this.$t('label.project.publish.submitFailure'), duration: 5})
        }
      })
    },
    submitForm () {
      this.$refs.publishForm.validate(valid => {
        if (valid) {
          this.publishModalLoading = true
          this.publish()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs.publishForm.resetFields()
    },
    loadSucceed (response, file, fileList) {
      console.log(response, file, fileList)
    },
    handleRemove () {

    },
    amountValidator (rule, mountVal, callback) {
      var regTel = /^\d+(\.\d+)?$/

      if (!regTel.test(mountVal)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
    },
    /**
     * 手机号验证规则
     */
    tel_validator (rule, telVal, callback) {
      let regTel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/

      if (!regTel.test(telVal)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
    },
    /**
     * 邮箱验证规则
     */
    mail_validator (rule, mailVal, callback) {
      let regTel = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/

      if (!regTel.test(mailVal)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
    }
  },
  created () {

  },
  mounted () {
  },
  activated () {

  }
}
</script>

<style scoped>

.pbr-add-project /deep/ .el-dialog {
  height: 90vh;
  overflow: scroll;
}

.pbr-add-project /deep/ .el-dialog .el-dialog__header {
  position: sticky;
  position: -webkit-sticky;
  /* position: sticky; */
  top: 0px;
  background: inherit;
  z-index: 9999;
}

.pbr-add-project .el-form-item /deep/ .el-form-item__error {
  padding-top: 0px;
}

.pbr-add-project .el-form-item {
  margin-bottom: 10px;
}

.pbr-add-project-icon {
  color: #008bce;
  padding: 0 10px;
  font-size: 18px;
}

.pbr-add-project-form-item-container {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  flex-wrap: wrap;
}

.pbr-add-project-form-item-container > div {
  flex: 0 0 50%;
}

.pbr-add-project-form-item-container /deep/ .el-select,
.pbr-add-project-form-item-container /deep/ .el-cascader {
  display: inherit;
}

.flex-fill > div {
  flex: 1;
}

/*home.css中有样式会覆盖element本来的样式，此处再重新覆盖回去*/
/deep/ .el-form-item__label {
  text-align: right;
  padding-left: 0;
  margin-right: 0;
}
</style>

<style>
.ivu-message {
  z-index: 3000 !important;
}

</style>
